import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import { AuthContext } from "../AuthContext/AuthContext";
import Topbar from "../Topbar/Topbar";
import ChatWidget from "../Chat/ChatWidget";
import ModalDevice from "./ModalDevice";
import "./Devices.css";

// ─── Catálogos de visualización ───────────────────────────────────────────────
const STATUS_LABEL = { 0: "Inactivo", 1: "Activo" };
const TYPE_LABEL = { 0: "Basic", 1: "Premium" };
const INSTALLATION_TYPE_LABEL = { escuela: "Escuela", hotel: "Hotel", otro: "Otro" };
const API_BASE = process.env.REACT_APP_API_BASE_URL;

const Devices = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const [devices,         setDevices]         = useState([]);
  const [filterText,      setFilterText]      = useState("");
  const [isAddModalOpen,  setIsAddModalOpen]  = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedDevice,  setSelectedDevice]  = useState(null);

  // ── Guardia de privilegio ──────────────────────────────────────────────────
  useEffect(() => {
    if (!user || !user.privileges?.devices) {
      navigate("/home", { replace: true });
    }
  }, [user, navigate]);

  // ── Clase CSS en body ──────────────────────────────────────────────────────
  useEffect(() => {
    document.body.classList.add("home-page");
    return () => document.body.classList.remove("home-page");
  }, []);

  // ── Carga inicial ──────────────────────────────────────────────────────────
  useEffect(() => {
    fetchDevices();
  }, []);

  // ── Fetch ──────────────────────────────────────────────────────────────────
  const fetchDevices = () => {
    fetch(`${API_BASE}/api/getDevices`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setDevices(data.devices);
      })
      .catch((err) => console.error("Error fetching devices:", err));
  };

  // ── Handlers de modales ────────────────────────────────────────────────────
  const openAddModal = () => setIsAddModalOpen(true);

  const closeAddModal = () => {
    setIsAddModalOpen(false);
    fetchDevices();
  };

  const handleRowClick = (row) => {
    fetch(`${API_BASE}/api/infoDevice?id_device=${row.id_device}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setSelectedDevice(data.device);
          setIsEditModalOpen(true);
        }
      })
      .catch((err) => console.error("Error loading device info:", err));
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedDevice(null);
    fetchDevices();
  };

  // ── Columnas del DataTable ─────────────────────────────────────────────────
  const columns = [
    {
      name:     "Instalación",
      selector: (row) => row.installation_name || row.keycode,
      sortable: true,
      wrap:     true,
    },
    {
      name:     "Perfil",
      selector: (row) => INSTALLATION_TYPE_LABEL[row.installation_type] || "—",
      sortable: true,
    },
    {
      name:     "Estado",
      selector: (row) => row.estado || "—",
      sortable: true,
    },
    {
      name:     "Municipio",
      selector: (row) => row.municipio || "—",
      sortable: true,
    },
    {
      name:     "Propietario",
      selector: (row) => row.user_name || "—",
      sortable: true,
      wrap:     true,
    },
    {
      name:     "Donante",
      selector: (row) => row.donor_name || "—",
      sortable: true,
      wrap:     true,
    },
    {
      name:     "Capacidad (L)",
      selector: (row) => row.tank_capacity_l || "—",
      sortable: true,
    },
    {
      name:     "HP",
      selector: (row) => row.hp || "—",
      sortable: true,
    },
    {
      name:     "Inicio de operación",
      selector: (row) => row.operation_start_date || "—",
      sortable: true,
    },
    {
      name:     "Plan",
      selector: (row) => TYPE_LABEL[row.type] ?? TYPE_LABEL[0],
      sortable: true,
    },
    {
      name:     "Estatus",
      selector: (row) => STATUS_LABEL[row.status] ?? row.status,
      sortable: true,
    },
  ];

  // ── Filtro de búsqueda ─────────────────────────────────────────────────────
  const filteredDevices = devices.filter((d) =>
    JSON.stringify(d).toLowerCase().includes(filterText.toLowerCase())
  );

  // ── Render ─────────────────────────────────────────────────────────────────
  return (
    <>
      <Topbar />
      <div className="home-container">
        <div className="content-container">

          <div className="header">
            <div className="header-title">
              <h1>Control de Dispositivos</h1>
            </div>
            <div className="header-buttons">
              <button className="btn btn-primary" onClick={openAddModal}>
                Agregar
              </button>
            </div>
          </div>

          <div className="devices-list">
            <p>
              Gestiona los dispositivos registrados en el sistema. Cada
              instalación tiene un propietario, opcionalmente un donante, y
              un perfil/ubicación que alimenta el portafolio institucional.
            </p>
            <div className="datatable-container">
              <input
                type="text"
                className="search-input"
                placeholder="Buscar..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
              <DataTable
                columns={columns}
                data={filteredDevices}
                pagination
                highlightOnHover
                striped
                onRowClicked={handleRowClick}
                paginationComponentOptions={{
                  rowsPerPageText: "Registros por página",
                  rangeSeparatorText: "de",
                }}
              />
            </div>
          </div>

        </div>
      </div>

      {/* Modal — agregar */}
      <ModalDevice
        isOpen={isAddModalOpen}
        onRequestClose={closeAddModal}
      />

      {/* Modal — editar */}
      {isEditModalOpen && (
        <ModalDevice
          isOpen={isEditModalOpen}
          onRequestClose={closeEditModal}
          deviceData={selectedDevice}
          isEditMode={true}
        />
      )}

      {/* Asistente (solo administradores con chat_token) */}
      <ChatWidget />
    </>
  );
};

export default Devices;